import React from 'react';

import {observer} from 'mobx-react';
import {SocialIconLink} from "../../../../../core/components/social-icons/social-icon-link";
import classNames from "classnames";
import styles from "../styles/footer.module.scss";
import {FOOTER_MODULE} from "../footer-module.consts";

export const FooterModuleSocialButtons = observer(({controller}) => {
  const {state, terms} = controller;
  const {socialLinks, isHomePage, isBettingPage} = state;
  const {facebook, twitter, instagram, youtube} = socialLinks;
  const {FOOTER_FACEBOOK_TITLE, FOOTER_FACEBOOK_ALT, FOOTER_TWITTER_TITLE, FOOTER_TWITTER_ALT, FOOTER_INSTAGRAM_TITLE, FOOTER_INSTAGRAM_ALT} = terms;

  const facebookProps = {
    url: facebook,
    size: FOOTER_MODULE.LOGOS.SOCIAL,
    title: FOOTER_FACEBOOK_TITLE,
    alt: FOOTER_FACEBOOK_ALT,
    name: 'Facebook',
    className: classNames(styles.social_button_icon),
    nofollow: !isHomePage
  }

  const twitterProps = {
    url: twitter,
    size: FOOTER_MODULE.LOGOS.SOCIAL,
    title: FOOTER_TWITTER_TITLE,
    alt: FOOTER_TWITTER_ALT,
    name: 'Twitter',
    className: classNames(styles.social_button_icon),
    nofollow: !isHomePage
  }

  const instagramProps = {
    url: instagram,
    size: FOOTER_MODULE.LOGOS.SOCIAL,
    title: FOOTER_INSTAGRAM_TITLE,
    alt: FOOTER_INSTAGRAM_ALT,
    name: 'Instagram',
    className: classNames(styles.social_button_icon),
    nofollow: !isHomePage
  }

  const youtubeProps = {
    url: !isBettingPage ? youtube : null,
    size: FOOTER_MODULE.LOGOS.SOCIAL,
    name: 'Basticast',
    className: classNames(styles.social_button_icon),
    nofollow: !isHomePage
  }

  return (
    <div className={styles.social_buttons}>
      <SocialIconLink {...facebookProps}/>
      <SocialIconLink  {...twitterProps}/>
      <SocialIconLink {...instagramProps}/>
      <SocialIconLink {...youtubeProps}/>
    </div>
  );
});
